import { DeleteOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Avatar,
  Badge,
  Col,
  Divider,
  Dropdown,
  Input,
  Row,
  Tooltip,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getAdminDetail, logout } from '../../../controller/localStroageHandler';
import routes from '../../../controller/Routes';
import { useUserStore } from '../../../store/userReducer';
import { useNotoficationStore } from '../../../store/notificationReducer';
import parse from 'html-react-parser';
import moment from 'moment';

const AdminSearchBarHeader = ({ search, setSearch }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const param = useParams();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [searchbarVisible, setSearchBarVisible] = useState(false);
  const userdetail=getAdminDetail()
  const { newNotification, notification, updateNotification } =
    useNotoficationStore((state) => state);
  const { user } = useUserStore((store) => store);
  useEffect(() => {
    console.log(location.pathname?.split('/'),"kknknknknknkn")
    if (location.pathname?.split('/')[2] == 'candidate'||location.pathname?.split('/').includes("candidate")) {
      setSearchBarVisible(true);
    }
    // getNotificationData();
  }, []);
//  const getNotificationData = () => {
//     getNotification()
//       .then((res) => {
//         updateNotification(res.data);
//       })
//       .catch((err) => console.log('err ====>', err));
//   };
  const handleSeen = (id) => {
    // updateseenNotification({ id: id },{is_seen:true})
    //   .then((res) => {
    //     getNotificationData();
    //   })
    //   .catch((err) => console.log('err ====>', err));
  };
  const handleDelete=(id)=>{
    // deleteNotification({id:id}).then(res=>{
    //   getNotificationData()
    // }).catch(err=> console.log('err ====>', err))
  }
  return (
    <Row align={'middle'}>
      <Col lg={21} xs={24}>
        {searchbarVisible && (
          <Input
            placeholder='Search Here'
            prefix={<SearchOutlined />}
            size='large'
            value={search}
            allowClear
            onChange={(e) => setSearch(e.target.value)}
          />
        )}
      </Col>
      <Col lg={3} xs={0} className='text-end'>
        <div className='d-flex justify-content-center align-items-center gap-2'>
          <Tooltip
            placement='bottomRight'
            color={'white'}
            overlayClassName='notification-tooltip'
            title={
              <div
                className='text-black w-100 d-flex flex-column gap-2 overflow-y-auto'
                style={{ maxHeight: '400px' }}
                onMouseLeave={() => setNotificationOpen(false)}
              >
                {notification?.length ? (
                  notification?.map((val, index) => {
                    return (
                      <div
                        className={`d-flex align-items-center gap-1 ${val?.is_seen==false&&"bg-light"}`}
                        key={index}
                      >
                        <Avatar
                          style={{
                            backgroundColor: '#C24A4A',
                            verticalAlign: 'middle',
                            fontSize: 16,
                            marginRight: '5px',
                          }}
                        >
                          {val?.name?.charAt(0)}
                        </Avatar>
                        <div className='d-flex flex-column fw-normal'>
                        {/* <div dangerouslySetInnerHTML={{ __html: val?.message }} /> */}
                        {parse(val?.message)}
                        <div className="d-flex gap-5">
                          <span
                            className='text-muted'
                            style={{ fontSize: '12px' }}
                          >
                            {moment(val?.created_at).format('DD-MM-YYYY')}
                          </span>
                          <div className="d-flex gap-2">
                          {val?.is_seen==false&&<EyeOutlined onClick={() => handleSeen(val?.id)} />}
                            <DeleteOutlined onClick={()=>{handleDelete(val?.id)}}/>
                          </div>
                        </div>
                      </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{ height: '10vh' }}
                    className='d-flex justify-content-center align-items-center text-muted'
                  >
                    No Notification
                  </div>
                )}
              </div>
            }
            open={notificationOpen}
          >
            <Badge count={newNotification}>
              <FontAwesomeIcon
                icon={faBell}
                style={{
                  fontSize: 18,
                  cursor: 'pointer',
                }}
                onMouseEnter={() => setNotificationOpen(true)}
              />
            </Badge>
          </Tooltip>
          <Divider type='vertical' />
          <Dropdown
            menu={{
              items: [{ label: 'logout', key: 1 }],
              onClick: (val) => {
                if (val?.key == 1) {
                  logout();
                  navigate(routes.admin.login);
                }
              },
            }}
          >
            <Avatar
              style={{
                backgroundColor: '#b2d8a7',
                verticalAlign: 'middle',
                fontSize: 16,
                marginRight: '10px',
                marginTop: '-8px',
              }}
              className='text-uppercase'
            >
             {userdetail?.firstName?.[0]}{userdetail?.lastName?.[0]}
            </Avatar>
          </Dropdown>
        </div>
      </Col>
    </Row>
  );
};

export default AdminSearchBarHeader;
